'use client'
import {useTranslations} from 'next-intl';
import {getNiceSelectValue} from '@/libs/jquery.util';
import {useEffect} from 'react';
import {CatalogSortSelectItems} from '@/libs/constants/common.constants';

export default function ShopSortSelect({ onSortSelect, sortValue }) {
  const t = useTranslations('catalog.sortItems');
  const sortItems = [
    { value: CatalogSortSelectItems.DEFAULT, name: t('default') },
    { value: CatalogSortSelectItems.NEW_ARRIVALS, name: t('byNewArrivals') },
    { value: CatalogSortSelectItems.PRICE_ASC, name: t('byPriceAsc') },
    { value: CatalogSortSelectItems.PRICE_DESC, name: t('byPriceDesc') }
  ];
  
  useEffect(() => {
    if (typeof window !== "undefined" && window.$) {
      window.$(".nice-select").niceSelect("update");
    }
    getNiceSelectValue((value) => {
      if (value === CatalogSortSelectItems.DEFAULT) {
        onSortSelect({
          value: { fieldName: 'reviewComputed.average', direction: 'DESC', nulls: 'LAST' },
          ref: CatalogSortSelectItems.DEFAULT
        });
      } else if (value === CatalogSortSelectItems.NEW_ARRIVALS) {
        onSortSelect({
          value: { fieldName: 'product.createdAt', direction: 'DESC' },
          ref: CatalogSortSelectItems.NEW_ARRIVALS
        });
      } else if (value === CatalogSortSelectItems.PRICE_ASC) {
        onSortSelect({
          value: { fieldName: 'prices.price', direction: 'ASC' },
          ref: CatalogSortSelectItems.PRICE_ASC
        });
      } else if (value === CatalogSortSelectItems.PRICE_DESC) {
        onSortSelect({
          value: { fieldName: 'prices.price', direction: 'DESC' },
          ref: CatalogSortSelectItems.PRICE_DESC
        });
      }
    }, null);
  }, [sortValue]);
  
  return (
      <div className="short-by text-center">
        <select
            className="nice-select"
            value={sortValue}
            onChange={() => {}}
        >
          {sortItems.map(({ value, name }, idx) => (
            <option
                key={idx}
                value={value}
            >
              {name}
            </option>
          ))}
        </select>
      </div>
  );
};
